module.exports = {
    GAP_ACCESS_URL: "/gap-access",
    GAP_URL_PRE: 'http://pre.openbank.intranet.corp/',
    GAP_URL_PRO: 'http://serviciosintranet.openbank.gs.corp/',
    GAP_RAISEN2_OK: 'OK'
};
